import styled from 'styled-components';

export const MultiDropdownContainer = styled.div`
    flex: 0 0 auto;
    position: relative;
`;

export const MultiDropdownTrigger = styled.h4`
    background-color: rgba(255, 255, 255, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.67);
    border-radius: 100px;
    box-sizing: border-box;
    cursor: pointer;
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: inherit;
    line-height: 26px;
    opacity: ${props => props.$isOpen ? 0.85 : 0.5};
    align-items: center;
    display: inline-flex;
    gap: 4px;
    justify-content: center;
    padding: 0 10px 0 12px;
    transition: opacity 0.15s ease;
    user-select: none;
    white-space: nowrap;

    &:hover {
        opacity: 0.75;
    }
`;

export const MultiDropdownChevron = styled.span`
    font-size: 8px;
    line-height: 1;
    opacity: 0.8;
`;

export const MultiDropdownPanel = styled.div`
    backdrop-filter: blur(12px);
    background: rgba(15, 15, 20, 0.96);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    min-width: 160px;
    padding: 4px 0;
    position: absolute;
    right: 0;
    top: calc(100% + 6px);
    z-index: 200;
`;

export const MultiDropdownOption = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-size: 12px;
    font-weight: 500;
    gap: 8px;
    letter-spacing: 0.04em;
    opacity: ${props => props.$isSelected ? 1 : 0.55};
    padding: 8px 14px;
    text-transform: uppercase;
    transition: background 0.15s ease, opacity 0.15s ease;
    white-space: nowrap;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
        opacity: 1;
    }

    input[type='checkbox'] {
        accent-color: #FFFFFF;
        cursor: pointer;
        flex-shrink: 0;
        height: 13px;
        pointer-events: none;
        width: 13px;
    }
`;
